<template>
  <div class='message-tags'>
    <span class="tag" :style="{ background: tag.color }" v-for="tag in tags" :key="tag.id">
      <a @click="findTaggedWith(tag.name)">{{tag.name}}</a>
      <a v-if="!index" class="delete" @click="removeTag(tag.name)">×</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Tags',
  props: ['tags', 'message_id', 'index'],
  methods: {
    removeTag (tag) {
      this.$http.put('/remove_tag', {message_id: this.message_id, tag: tag})
        .then(response => {
          this.$store.dispatch('reloadMessage')
        })
        .catch(e => { console.log(e) })
    },
    findTaggedWith (tag) {
      this.$root.$emit('tagSearchInitiated', tag)
    }
  }
}
</script>

<style scoped>
  .message-tags {
    float: left;
    overflow: hidden;
    color: #ffffff;
    margin-left: 5px;
    width: 100%;
  }
  .tag {
    border-radius: 2px;
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 4px;
    cursor: pointer;
    line-height: 12px;
    margin: 6px 2px 0px 1px;
    background: #6c757d;
    float: left;
  }
  .delete {
    display: inline-block;
    font-size: 13px;
    margin-left: 2px;
    padding-right: 4px;
    text-decoration: none;
  }
  .conversation-column > .message-tags {
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tags.vue